// The editor code uses mapboxgl and MapboxGeocoder as globals, as it did when
// both came from the Sprockets bundle. Import this module before the editor.
// mapboxgl must be on window before the geocoder file runs.
import './mapbox-global';
import * as geocoderModule from './vendor/mapbox-gl-geocoder';

// The vendored geocoder is a UMD build: the production bundler treats it as
// CommonJS and exports it, while the dev server runs it as a plain script that
// sets window.MapboxGeocoder itself.
window.MapboxGeocoder = window.MapboxGeocoder || geocoderModule.default;
